import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import useLocale from '../localization/useLocale';

type SitePageMap = Map<string, string>;

type RouteType = {
  path: string;
  context: {
    id: string;
    locale?: string;
  };
};

const query = graphql`
  query SitePageData {
    allSitePage {
      edges {
        node {
          path
          context {
            id
            locale
          }
        }
      }
    }
  }
`;

// Prefer paths matching the current locale when the same id maps to multiple pages
const useSitePageData = (): SitePageMap => {
  const { allSitePage } = useStaticQuery(query);
  const locale = useLocale();

  return React.useMemo(() => {
    const map = new Map<string, string>();
    allSitePage.edges.forEach(({ node }: { node: RouteType }) => {
      const id = node.context?.id;
      if (!id) return;
      if (!map.has(id) || node.context?.locale === locale) {
        map.set(id, node.path);
      }
    });
    return map;
  }, [allSitePage, locale]);
};

export default useSitePageData;
